import { ReactComponent as Icon } from 'assets/img/done_icon.svg';

export default function IconComplete() {
  return (
    <>
      <Icon />
    </>
  );
}